import { captureMessage } from '@sentry/nextjs'

import fetchRequest from '@/app/_utils/fetch-request'

import { validateThirdPartyScripts } from './response-data-validator'

export const fetchThirdPartyScriptsConfig = async (isServerSideRequest: boolean) => {
    const response = await fetchRequest({
        method: 'GET',
        serviceName: 'cml',
        endpoint: '/cases/third-party-scripts',
        isServerSideRequest,
        onError: (error) =>
            captureMessage('third-party-scripts: fetch failed!', {
                tags: {
                    feature: 'third-party-scripts',
                    reason: 'schema_validation_failed',
                    sampleRate: '1.0',
                },
                extra: {
                    error,
                },
            }),
    })

    const result = validateThirdPartyScripts(response)

    return result
}
